module.exports = __webpack_public_path__ + "public/images/learner_growth.5feb64d752fdfc51789e45f77950009e.png";